"use client";
import React, { useState, useEffect, useMemo } from "react";
import MonthDateTags from "./Vietnamavailabledates ";
import BhutanForm from "./Vietnamform";

export default function Herosection() {
  const [displayText, setDisplayText] = useState("");
  const [isTyping, setIsTyping] = useState(true);
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  const words = useMemo(() => ["Vietnam", "PhuQuoc", "DaNang", "Ha Noi"], []);

  useEffect(() => {
    const currentWord = words[currentWordIndex];
    let timeoutId;

    if (isTyping) {
      if (displayText.length < currentWord.length) {
        timeoutId = setTimeout(() => {
          setDisplayText(currentWord.slice(0, displayText.length + 1));
        }, 120);
      } else {
        timeoutId = setTimeout(() => {
          setIsTyping(false);
        }, 2000);
      }
    } else {
      if (displayText.length > 0) {
        timeoutId = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, 80);
      } else {
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % words.length);
        setIsTyping(true);
      }
    }

    return () => clearTimeout(timeoutId);
  }, [displayText, isTyping, currentWordIndex, words]);

  return (
    <>
      <div
        className="container-fluid blue-brand-bg-color p-3 d-flex flex-wrap justify-content-center"
        style={{ marginTop: "80px" }}
      >
        <h1 className="keyword-title text-center text-white m-0">
          Vietnam Tour Packages from Bangalore
        </h1>
      </div>

      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-md-7 px-md-5 py-3">
            <div className="m-0">
              <h6 className="amazing-title orange-brand-color m-0">Explore</h6>
              <h2 className="package-title blue-brand-color m-0 d-flex align-items-baseline">
                <span className="typing-wrapper">
                  <span className="invisible-placeholder">
                    {words.reduce((a, b) => (a.length > b.length ? a : b))}
                  </span>
                  <span className="visible-text">{displayText}</span>
                  <span className="typing-cursor">|</span>
                </span>
              </h2>
            </div>

            <div className="row g-0 p-3 px-md-5">
              <div className="col-12 col-sm-5 blue-brand-bg-color text-white d-flex align-items-center justify-content-center p-3">
                <h6 className="m-0 fw-bold text-center">4 Days | 3 Nights</h6>
              </div>
              <div className="col-12 col-sm-7 orange-brand-bg-color border border-dark text-white p-3">
                <h6 className="m-0 text-center">
                  <span className="price-font">Starting From </span>
                  <strong>INR 1,35,000*</strong>{" "}
                  <span className="price-font"> Per Person</span>
                </h6>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-center gap-3 my-3">
              <div className="d-flex align-items-center">
                <i
                  className="bi bi-building d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle fs-4 me-2"
                  style={{ width: "45px", height: "45px", flexShrink: 0 }}
                ></i>
                <span className="fw-bold blue-brand-color pe-3 border-end">
                  Hotels
                </span>
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="bi bi-fork-knife d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle fs-4 me-2"
                  style={{ width: "45px", height: "45px", flexShrink: 0 }}
                ></i>
                <span className="fw-bold blue-brand-color pe-3 border-end">
                  Meals
                </span>
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="bi bi-binoculars d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle fs-4 me-2"
                  style={{ width: "45px", height: "45px", flexShrink: 0 }}
                ></i>
                <span className="fw-bold blue-brand-color pe-3 border-end">
                  Sightseeing
                </span>
              </div>
              <div className="d-flex align-items-center">
                <i
                  className="bi bi-bus-front d-flex align-items-center justify-content-center orange-brand-color bg-blue-brand rounded-circle fs-4 me-2"
                  style={{ width: "45px", height: "45px", flexShrink: 0 }}
                ></i>
                <span className="fw-bold blue-brand-color pe-3">Transfers</span>
              </div>
            </div>

            <MonthDateTags />
          </div>

          <div className="col-12 col-md-5" id="hero-section">
            <BhutanForm />
          </div>
        </div>
      </div>

      <style jsx>{`
        .typing-cursor {
          animation: blink 1s infinite;
          color: inherit;
          margin-left: 2px;
          display: inline-block;
          vertical-align: baseline;
        }

        @keyframes blink {
          0%,
          50% {
            opacity: 1;
          }
          51%,
          100% {
            opacity: 0;
          }
        }

        .package-title {
          overflow: hidden;
        }

        .typing-wrapper {
          position: relative;
          display: inline-block;
          font-weight: bold;
        }

        .invisible-placeholder {
          visibility: hidden;
          white-space: nowrap;
          position: absolute;
          top: 0;
          left: 0;
        }

        .visible-text {
          white-space: nowrap;
          position: relative;
        }
      `}</style>
    </>
  );
}
